import { $path } from '../path';
import { $svg, UISVGContent } from '../svg';
import { UIPoint } from '../types';

export class Arc implements UISVGContent {
    root: SVGPathElement;

    private _c: UIPoint;
    private _r1: number;
    private _r2: number;
    private _s: number;
    private _e: number;

    constructor(c: UIPoint, r1: number, r2: number, s: number, e: number) {
        this.root = $svg.PATH();

        this._c = c;
        this._r1 = r1;
        this._r2 = r2;
        this._s = s;
        this._e = e;

        this._calcPath();
    }

    private _calcPath() {
        const c = this._c;
        const r1 = this._r1;
        const r2 = this._r2;
        const s = this._s;
        const e = this._e;

        $path.start();
        $path.arc(c[0], c[1], r1, s, e, false);
        $path.arc(c[0], c[1], r2, e, s, true);
        $path.close();
        $path.setTo(this.root);
    }

    get outer_center() {
        const a = (this._s + this._e) / 2;
        const r = this._r2;
        return [this._c[0] + Math.cos(a) * r, this._c[1] + Math.sin(a) * r];
    }

    set start(s: number) {
        this._s = s;
        this._calcPath();
    }

    set end(e: number) {
        this._e = e;
        this._calcPath();
    }
}
